import React, { Component } from 'react';
import Footer from './footer';
import Header from './header';
import Section2Top from './data/section_2_top.jpg';
import Form from './form';



class Section2 extends Component {
    state = {  } 
    render() { 
        return (
            <div className='d-flex flex-column min-vh-100 '>
                <Header onlanguage={this.props.onlanguage}
                    onChangeLanguage={this.props.onChangeLanguage}
                    onEngLanguage={this.props.onEngLanguage}
                    onGeoLanguage={this.props.onGeoLanguage}
                />
                <img src={Section2Top} alt="section1 top"  className='section-top'/>
                <div className='pb-2 flex-grow-1'>
                    <div className='row w-100 p-0 m-0'>
                            <div className='col-12 col-lg-9 py-2 pe-lg-4' style={{backgroundColor: '#F0F0F0', lineHeight: '2'}}>
                                <div className='custom-font-size-text-2 px-0 px-sm-3 px-md-4 px-xl-5 mt-2' style={{ textAlign: 'justify', textJustify: 'inter-word'}}>
                                    <div className={this.props.onEngLanguage()}>
                                         <div className='pe-0 pe-lg-5'>
                                            <div>
                                                <div>
                                                    <b>ტრენინგის შესახებ</b>
                                                </div>
                                                <div>
                                                    ტრენინგის მიზანია მონაწილეს გააცნოს კორპორაციული მართვის პრინციპები და 
                                                    საოპერაციო რისკის მართვის პროგრამის საბაზისო ელემენტები. ტრენინგი ეფუძნება 
                                                    საერთაშორისო სტანდარტებს (ISO, COSO, Basel) და შეესაბამება
                                                    ეროვნული ბანკის რეგულაციის მოთხოვნებს.
                                                </div>
                                                <div>
                                                    ტრენინგი დაეხმარება მონაწილეს გაეცნოს ეროვნული ბანკის „მიკროსაფინანსო
                                                    ორგანიზაციების საქმიანობის ზედამხედველობისა და რეგულირების წესით“
                                                    განსაზღვრული ახალი მოთხოვნების შინაარსს, მოამზადოს ცვლილებების პაკეტი და
                                                    დანერგოს ორგანიზაციაში რეგულაციით მოთხოვნილი პროცესები.
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>ვისთვისაა ტრენინგი განკუთვნილი</b>
                                                </div>
                                                <div>
                                                    ტრენინგი განკუთვნილია მიკროსაფინასო ორგანიზაციებში მომუშავე საშუალო და მაღალი
                                                    რგოლის მენეჯერებისათვის, აგრეთვე რისკის მართვის პროცესების ორგანიზებაზე
                                                    პასუხისმგებელი თანამშრომლებისათვის.
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>ტრენინგის დასრულების შემდეგ</b>
                                                </div>
                                                <div>
                                                    მონაწილე შეძლებს საოპერაციო რისკის მართვის პროცესების
                                                    ეროვნული ბანკის რეგულაციის შესაბამისობაში ჩამოყალიბებასა და ორგანიზებას,
                                                    აგრეთვე შეიძენს ცოდნას საოპერაციო რისკის დანაკარგების გამოვლენისა და ზარალის
                                                    მინიმიზაციის პრაქტიკული მიდგომების შესახებ.
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>ტრენინგის შინაარსი</b>
                                                </div>
                                                <div>
                                                    დღე 1
                                                    <ul>
                                                        <li>კორპორაციული მართვის პრინციპები</li>
                                                        <li>რისკის მართვის როლები და პასუხისმგებლობები</li>
                                                        <li>აუდიტის და რისკების კომიტეტის როლები</li>
                                                        <li>საოპერაციო რისკის მართვის ჩარჩო</li>
                                                        <li>საოპერაციო რისკის კატეგორიები და მოვლენები</li>
                                                    </ul>
                                                    დღე 2
                                                    <ul>
                                                        <li>საოპერაციო რისკის მართვის ინსტრუმენტები</li>
                                                        <li>საოპერაციო რისკის იდენტიფიკაციის მეთოდები</li>
                                                        <li>საოპერაციო ინციდენტების აღრიცხვა და ანალიზი</li>
                                                        <li>რისკების თვით-შეფასების პროგრამა</li>
                                                        <li>რისკის მონიტორინგი</li>
                                                    </ul>
                                                    დღე 3
                                                    <ul>
                                                        <li>ბიზნესის უწყვეტობის მართვა და კრიზისის მართვა</li>
                                                        <li>საოპერაციო პროგრამების მდგრადობისა და უსაფრთხოების მიმართ მოთხოვნები</li>
                                                        <li>მონაცემთა აღრიცხვის სტანდარტები და მოთხოვნების დანერგვის მიდგომები</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>ტრენერის შესახებ</b>
                                                </div>
                                                <div>
                                                    ნინო ოქრუაშვილი ფლობს 15+ წლიან გამოცდილებას რისკების მართვის პროგრამების შემუშავებისა და განვითარების კუთხით. 
                                                    გააჩნია საერთაშორისო სტანდარტებისა და რეგულატორული მოთხოვნების ექსპერტული ცოდნა.
                                                </div>
                                                <div>
                                                    მას აქვს ტრენინგებისა და ცნობიერების ამაღლების პროგრამების
                                                    ორგანიზების მრავალწლიანი გამოცდილება კორპორატიულ გარემოში.
                                                </div>
                                                <div>
                                                    გავლილი აქვს საოპერაციო რისკების მართვისა და ბიზნესის უწყვეტობის მართვის
                                                    საერთაშორისო სასერტიფიკატო კურსები, ორგანიზებული წამყვანი რისკის მართვის 
                                                    ინსტიტუტების მიერ.
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>კორპორატიული შეთავაზება</b>
                                                </div>
                                                <div>
                                                    ჩვენ გთავაზობთ თქვენი ორგანიზაციის საჭიროებებზე მორგებულ რისკების სატრენინგო პროგრამის ორგანიზებას. დაინტერესების შემთხვევაში, 
                                                    დაგვიკავშირდით მეილზე: info@riskadvisor.ge და ერთად დავგეგმოთ თქვენთვის სასურველი ტრენინგი.
                                                     
                                                </div>
                                            
                                            </div>
                                        </div>
                                    </div>
                                    <div className={this.props.onGeoLanguage()}>
                                        <div className='pe-0 pe-lg-5'>
                                            <div>
                                                <div>
                                                    <b>ტრენინგის შესახებ</b>
                                                </div>
                                                <div>
                                                    ტრენინგის მიზანია მონაწილეს გააცნოს კორპორაციული მართვის პრინციპები და 
                                                    საოპერაციო რისკის მართვის პროგრამის საბაზისო ელემენტები. ტრენინგი ეფუძნება 
                                                    საერთაშორისო სტანდარტებს (ISO, COSO, Basel) და შეესაბამება
                                                    ეროვნული ბანკის რეგულაციის მოთხოვნებს.
                                                </div>
                                                <div>
                                                    ტრენინგი დაეხმარება მონაწილეს გაეცნოს ეროვნული ბანკის „მიკროსაფინანსო
                                                    ორგანიზაციების საქმიანობის ზედამხედველობისა და რეგულირების წესით“
                                                    განსაზღვრული ახალი მოთხოვნების შინაარსს, მოამზადოს ცვლილებების პაკეტი და
                                                    დანერგოს ორგანიზაციაში რეგულაციით მოთხოვნილი პროცესები.
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>ვისთვისაა ტრენინგი განკუთვნილი</b>
                                                </div>
                                                <div>
                                                    ტრენინგი განკუთვნილია მიკროსაფინასო ორგანიზაციებში მომუშავე საშუალო და მაღალი
                                                    რგოლის მენეჯერებისათვის, აგრეთვე რისკის მართვის პროცესების ორგანიზებაზე
                                                    პასუხისმგებელი თანამშრომლებისათვის.
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>ტრენინგის დასრულების შემდეგ</b>
                                                </div>
                                                <div>
                                                    მონაწილე შეძლებს საოპერაციო რისკის მართვის პროცესების
                                                    ეროვნული ბანკის რეგულაციის შესაბამისობაში ჩამოყალიბებასა და ორგანიზებას,
                                                    აგრეთვე შეიძენს ცოდნას საოპერაციო რისკის დანაკარგების გამოვლენისა და ზარალის
                                                    მინიმიზაციის პრაქტიკული მიდგომების შესახებ.
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>ტრენინგის შინაარსი</b>
                                                </div>
                                                <div>
                                                    დღე 1
                                                    <ul>
                                                        <li>კორპორაციული მართვის პრინციპები</li>
                                                        <li>რისკის მართვის როლები და პასუხისმგებლობები</li>
                                                        <li>აუდიტის და რისკების კომიტეტის როლები</li>
                                                        <li>საოპერაციო რისკის მართვის ჩარჩო</li>
                                                        <li>საოპერაციო რისკის კატეგორიები და მოვლენები</li>
                                                    </ul>
                                                    დღე 2
                                                    <ul>
                                                        <li>საოპერაციო რისკის მართვის ინსტრუმენტები</li>
                                                        <li>საოპერაციო რისკის იდენტიფიკაციის მეთოდები</li>
                                                        <li>საოპერაციო ინციდენტების აღრიცხვა და ანალიზი</li>
                                                        <li>რისკების თვით-შეფასების პროგრამა</li>
                                                        <li>რისკის მონიტორინგი</li>
                                                    </ul>
                                                    დღე 3
                                                    <ul>
                                                        <li>ბიზნესის უწყვეტობის მართვა და კრიზისის მართვა</li>
                                                        <li>საოპერაციო პროგრამების მდგრადობისა და უსაფრთხოების მიმართ მოთხოვნები</li>
                                                        <li>მონაცემთა აღრიცხვის სტანდარტები და მოთხოვნების დანერგვის მიდგომები</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>ტრენერის შესახებ</b>
                                                </div>
                                                <div>
                                                    ნინო ოქრუაშვილი ფლობს 15+ წლიან გამოცდილებას რისკების მართვის პროგრამების შემუშავებისა და განვითარების კუთხით. 
                                                    გააჩნია საერთაშორისო სტანდარტებისა და რეგულატორული მოთხოვნების ექსპერტული ცოდნა.
                                                </div>
                                                <div>
                                                    მას აქვს ტრენინგებისა და ცნობიერების ამაღლების პროგრამების
                                                    ორგანიზების მრავალწლიანი გამოცდილება კორპორატიულ გარემოში.
                                                </div>
                                                <div>
                                                    გავლილი აქვს საოპერაციო რისკების მართვისა და ბიზნესის უწყვეტობის მართვის
                                                    საერთაშორისო სასერტიფიკატო კურსები, ორგანიზებული წამყვანი რისკის მართვის 
                                                    ინსტიტუტების მიერ.
                                                </div>
                                            </div>
                                            <br />
                                            <div>
                                                <div>
                                                    <b>კორპორატიული შეთავაზება</b>
                                                </div>
                                                <div>
                                                    ჩვენ გთავაზობთ თქვენი ორგანიზაციის საჭიროებებზე მორგებულ რისკების სატრენინგო პროგრამის ორგანიზებას. დაინტერესების შემთხვევაში, 
                                                    დაგვიკავშირდით მეილზე: info@riskadvisor.ge და ერთად დავგეგმოთ თქვენთვის სასურველი ტრენინგი.
                                                     
                                                </div>
                                            
                                            </div>
                                        </div>
                                    </div>
                                </div>   
                            </div>
                            <div className='col-12 col-lg-3 py-2 pe-xl-5' style={{backgroundColor: '#F0F0F0', lineHeight: '2'}}>
                                <div className='custom-font-size-text-2 px-0 px-sm-3 px-md-4 px-lg-0 mt-2'>
                                    <br />
                                    <div className='d-block position-relative mx-5 my-5 mx-lg-2 mx-xl-4 my-xxl-5' >
                                        <a href="#form" >
                                            <div className='position-absolute bottom-0 start-50 translate-middle-x' style={{color: 'white',width: '100%', textAlign: 'center' }} >
                                                <div className='h5 mb-3 py-1 rounded register_button' style={{backgroundColor: '#003968'}}>
                                                    <div className={this.props.onEngLanguage()}>
                                                        Register
                                                    </div>
                                                    <div className={this.props.onGeoLanguage()}>
                                                        რეგისტრაცია
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <br />
                                    <div className={this.props.onEngLanguage()}>
                                        <div>
                                            <div>
                                                <b>ტრენინგის თარიღი</b> <br /> 08-10 ოქტომბერი 2025
                                            </div>
                                            <br />
                                            <div>
                                                <b>ტრენინგის ხანგძლივობა და ფორმატი</b>
                                            </div>
                                            <div>
                                                3 შეხვედრა (12 საათი),
                                                ტრენინგი ჩატარდება
                                                შეხვედრების ფორმატში
                                            </div>
                                        </div>
                                        <br />
                                        <div>
                                            <div>
                                                <b>ტრენინგის ღირებულება</b>
                                            </div>
                                            <div>
                                                ადრეული რეგისტრაცია
                                                (31.08.25-მდე),<br />
                                                1 მონაწილე - 1690 ლარი
                                                (+დღგ) (-30%) <br />
                                                1 მონაწილე - 2300 ლარი
                                                (+დღგ)
                                            </div>
                                        </div>
                                    </div>
                                    <div className={this.props.onGeoLanguage()}>
                                        <div>
                                            <div>
                                                <b>ტრენინგის თარიღი</b> <br /> 08-10 ოქტომბერი 2025
                                            </div>
                                            <br />
                                            <div>
                                                <b>ტრენინგის ხანგძლივობა და ფორმატი</b>
                                            </div>
                                            <div>
                                                3 შეხვედრა (12 საათი),
                                                ტრენინგი ჩატარდება
                                                შეხვედრების ფორმატში
                                            </div>
                                        </div>
                                        <br />
                                        <div>
                                            <div>
                                                <b>ტრენინგის ღირებულება</b>
                                            </div>
                                            <div>
                                                ადრეული რეგისტრაცია
                                                (31.08.25-მდე),<br />
                                                1 მონაწილე - 1690 ლარი
                                                (+დღგ) (-30%) <br />
                                                1 მონაწილე - 2300 ლარი
                                                (+დღგ)
                                            </div>
                                        </div>
                                    </div>
                                    <br />
                                    <div id='form' style={{scrollMarginTop: '85px'}}>
                                        <Form 
                                            onlanguage={this.props.onlanguage}
                                            onChangeLanguage={this.props.onChangeLanguage}
                                            onEngLanguage={this.props.onEngLanguage}
                                            onGeoLanguage={this.props.onGeoLanguage}
                                            program={'risk_management_for_microfinance'}
                                            />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <br />
                        <br />
                </div>        
                <Footer
                    onlanguage={this.props.onlanguage}
                    onChangeLanguage={this.props.onChangeLanguage}
                    onEngLanguage={this.props.onEngLanguage}
                    onGeoLanguage={this.props.onGeoLanguage}/>
            </div>
        );
    }
}
 
export default Section2 ;
 
